"use client";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { usePayments } from "../../hooks/usePayments";
import Image from "next/image";
import PaymentWall from "./steps/paymentWall/paymentWall";
import PaymentForm from "./steps/paymentForm/ui/paymentForm";
import { cn } from "@/lib/utils";

export default function PaymentsModal() {
    const [open, setOpen, currentStep] = usePayments((state) => [
        state.paymentModalOpen,
        state.setPaymentModalOpen,
        state.currentStep,
    ]);

    return (
        <Dialog open={open} onOpenChange={(open) => setOpen(open, currentStep)}>
            <DialogContent
                xPosition={
                    currentStep === "PaymentWall" ? "top-1 left-1" : undefined
                }
                className={cn(
                    "p-4",
                    currentStep === "PaymentWall"
                        ? "max-w-[800px]"
                        : "max-w-[380px]"
                )}
            >
                <div className="flex w-full h-full flex-col md:flex-row-reverse gap-6">
                    {currentStep === "PaymentWall" && (
                        <div className="flex-1">
                            <Image
                                className="h-full w-full object-cover rounded-lg"
                                src="/images/payments/modal-image.png"
                                alt="image"
                                width={500}
                                height={500}
                                quality={100}
                            />
                        </div>
                    )}
                    {currentStep === "PaymentWall" && <PaymentWall />}
                    {currentStep === "PaymentForm" && <PaymentForm />}
                </div>
            </DialogContent>
        </Dialog>
    );
}
